import { iconAlertaCritico } from '@bsds-lib-component/icons/icons';
import { BsdsIcon } from '@bsds-lib-component/react';
import React, { useId } from 'react';
import { useNavigate } from 'react-router-dom';

import { Button } from '../../components';

const UnauthorizedPage: React.FC = () => {
  const navigate = useNavigate();
  const errorMessageId = useId();
  const mainContentId = useId();

  const handleGoHome = () => {
    navigate('/home');
  };

  return (
    <div
      className="min-h-screen-safe min-w-screen bsds-display-flex bsds-justify-content-center bsds-align-items-center bg-white"
      role="main"
      aria-label="Página de acesso negado"
    >
      <div className="bsds-width-100 bsds-align-items-center bsds-justify-content-center">
        {/* Main container */}
        <div
          id={mainContentId}
          className="bsds-width-100 h-full bsds-align-items-center bsds-justify-content-center rounded-none relative"
          role="region"
          aria-label="Conteúdo da página de erro de acesso"
        >
          <div className="bsds-width-100 h-full space-y-6 py-8 px-8 bsds-flex-column rounded-none mx-auto">
            {/* Unauthorized error icon */}
            <div className="bsds-display-flex bsds-justify-content-center bsds-mb-16">
              <div
                className="bsds-display-flex bsds-justify-content-center bsds-align-items-center rounded-full bg-system-danger-100/50 w-44 h-44"
                role="img"
                aria-label="Ícone de alerta de acesso negado"
              >
                <BsdsIcon
                  icon={iconAlertaCritico}
                  color="primary"
                  className="bsds-width-20 bsds-height-20 bsds-text-content-main-contrast-highlight"
                  aria-hidden="true"
                />
              </div>
            </div>

            {/* Main title */}
            <div className="bsds-mb-24">
              <h1 className="bsds-text-center bsds-mb-8 bsds-text-4xl bsds-text-bold text-system-danger-base text-bold">
                403
              </h1>
              <h2 className="bsds-text-center bsds-mb-8 bsds-text-2xl bsds-text-bold">
                Acesso Negado
              </h2>
              <p
                id={errorMessageId}
                className="bsds-text-center bsds-text-lg text-text-color"
                role="alert"
                aria-live="assertive"
              >
                Você não tem permissão para acessar esta página
              </p>
            </div>

            {/* Action buttons */}
            <div className="bsds-mt-36">
              <Button
                color="primary"
                onClick={handleGoHome}
                fill="solid"
                className="max-w-md mx-auto"
                aria-label="Voltar para a página inicial"
              >
                Ir para o início
              </Button>
            </div>

            {/* Additional information */}
            <div className="bsds-mt-16">
              <p className="bsds-text-center text-text-color" style={{ fontSize: '14px' }}>
                Se você acredita que isso é um erro, entre em contato com o administrador
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UnauthorizedPage;

